/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IProductComparisonButtonViewProps } from './product-comparison-button';

/**
 * Represents product comparison button view.
 * @param props - View props for product comparison button.
 * @returns Functional component of product comparison button.
 */
export const ProductComparisonButtonViewFunctionalComponent: React.FC<IProductComparisonButtonViewProps> = props => {
    const { productComparisonButton, productComparisonPreview } = props;

    return (
        <Module {...props.moduleProps}>
            {productComparisonButton}
            {productComparisonPreview}
        </Module>
    );
};

export default ProductComparisonButtonViewFunctionalComponent;
